import {ProductInfo} from '../product/productInfo';

export class Item {
  productInfo: ProductInfo;
  price: number;
  quantity: number;


  constructor(productInfo: ProductInfo, price: number, quantity: number) {
    this.productInfo = productInfo;
    this.price = price;
    this.quantity = quantity;
  }

  public getProductInfo(): ProductInfo {
    return this.productInfo;
  }

  public getPrice(): number {
    return this.price;
  }

  public getQuantity(): number {
    return this.quantity;
  }
}
